module.exports = "/_next/static/images/OgSegmentIndustryMobile-8428194c42ed970d33149f5813bf1bb5.png";